import { memo } from 'react';
import HubNode from './nodes/HubNode';
import ZoneNode from './nodes/ZoneNode';

interface CustomNodeProps {
  data: {
    label: string;
    type: 'hub' | 'zone';
    description?: string;
  };
}

function CustomNode({ data }: CustomNodeProps) {
  // Render either a HubNode or ZoneNode based on the type
  if (data.type === 'hub') {
    return <HubNode data={{ label: data.label, description: data.description }} />;
  } else {
    return <ZoneNode data={{ label: data.label, description: data.description }} />;
  }
}

export default memo(CustomNode);
